<div class="dashboard-grid" #gridContainer style="position:relative;">
  @if (isEditMode && isGridOverlayVisible) {
  <div class="grid-overlay" aria-hidden="true">
    @for (cell of gridOverlayCells; track $index) {
    <div
      class="grid-cell"
      [style.left.px]="cell.x"
      [style.top.px]="cell.y"
      [style.width.px]="gridSize"
      [style.height.px]="gridSize"
      [class.highlight]="isPreviewOriginCell(cell)"
      [class.card-area]="isPreviewAreaCell(cell)">
    </div>
    }
  </div>
  }

  <!-- Render each card in its grid position -->
  @for (widgetConfig of widgets; track widgetConfig.widgetKey) {
  <via-widget-container
    [class]="widgetConfig.isDragging ? 'dragging-card' : ''"

    [isLiveData]="isLiveData"
    [isEditMode]="isEditMode"
    [gridSize]="gridSize" 
    [widgetConfig]="widgetConfig"
    [draggable]="isEditMode"
    [resizable]="isEditMode"

    (closed)="onWidgetClosed(widgetConfig.widgetKey)"
    (widgetSnapped)="onWidgetSnapped(widgetConfig.widgetKey, $event)"
    (widgetPositionChanged)="onWidgetPositionChanged(widgetConfig.widgetKey, $event)"
    (widgetPreviewAddressChanged)="onWidgetPreviewAddressChanged($event)"
    (widgetDragStart)="onWidgetDragStart(widgetConfig.widgetKey)"
    (widgetDragEnd)="onWidgetDragEnd(widgetConfig.widgetKey)">
  </via-widget-container>
  }

</div>
